import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-games-leaderboard-nav',
  templateUrl: './games-leaderboard-nav.component.html',
  styleUrl: './games-leaderboard-nav.component.scss',
})
export class GamesLeaderboardNavComponent {
  @Input() routeLink: string;
  @Input() isRulesEnabled: boolean = false;
}
